import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-truncate" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_VZDeleteModal = _resolveComponent("VZDeleteModal")!
  const _component_DeviceDetailModal = _resolveComponent("DeviceDetailModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Datatable, {
      "table-data": _ctx.tableData,
      "table-header": _ctx.tableHeader,
      tableFilter: _ctx.tableFilter,
      total: _ctx.total,
      rowsPerPage: _ctx.rowsPerPage,
      page: _ctx.page,
      loading: _ctx.loading,
      showSearch: _ctx.showSearch,
      bulkDelete: _ctx.bulkDelete,
      viewName: _ctx.viewName,
      onQueryUpdate: _ctx.syncQuery,
      onFormSubmit: _ctx.submit,
      onBulkDelete: _ctx.onBulkDelete,
      permissions: _ctx.permissionModel,
      ref: "Datatable"
    }, {
      "cell-siteName": _withCtx(({ row: site }) => [
        _createTextVNode(_toDisplayString(site.siteName), 1)
      ]),
      "cell-deviceName": _withCtx(({ row: site }) => [
        _createTextVNode(_toDisplayString(site.deviceName), 1)
      ]),
      "cell-createdBy": _withCtx(({ row: site }) => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(site.createdBy), 1)
      ]),
      "cell-actions": _withCtx(({ row: site }) => [
        (_ctx.hasPermission(_ctx.permissionModel.delete))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _withModifiers(
          () => {
            _ctx.showDeleteDialog = true;
            _ctx.selectedForAction = site;
          }
        , ["stop"]),
              class: "btn btn-icon btn-danger btn-circle btn-sm ms-3"
            }, _hoisted_4, 8, _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["table-data", "table-header", "tableFilter", "total", "rowsPerPage", "page", "loading", "showSearch", "bulkDelete", "viewName", "onQueryUpdate", "onFormSubmit", "onBulkDelete", "permissions"]),
    _createVNode(_component_VZDeleteModal, {
      viewName: _ctx.viewName,
      pageName: "device",
      showDialog: _ctx.showDeleteDialog,
      selectedForAction: [_ctx.selectedForAction.webId],
      deleteText: `${_ctx.t('validation.sureToDelete')} ${
      _ctx.selectedForAction.deviceName
    }?`,
      onClose: _ctx.refreshList,
      onBulkDelete: _ctx.onBulkDelete
    }, null, 8, ["viewName", "showDialog", "selectedForAction", "deleteText", "onClose", "onBulkDelete"]),
    _createVNode(_component_DeviceDetailModal, {
      viewName: "device_detail_modal",
      data: _ctx.deviceDetail,
      showDialog: _ctx.showDetailDialog,
      onCloseDetail: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDetailDialog = false))
    }, null, 8, ["data", "showDialog"])
  ], 64))
}